export default {
  groupName: 'adpi-category-wireless',
  appName: 'Wireless Category',
  baseRoute: '/dashboard/adpi-category-wireless',
  label: 'AdPi Quickview Wireless Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'AdPi Quickview Wireless Dashboard'
}
